export default __webpack_public_path__ + "static/media/hla_icon.fd6e1d6d.svg";